import { faMoneyBillSimpleWave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type AllowanceProductBadgeProps = {
  price: string;
};

export const AllowanceProductBadge = ({
  price
}: AllowanceProductBadgeProps) => (
  <div className="flex w-fit items-center gap-2 rounded-full bg-kiosk-background-success px-3 py-1 font-bold text-kiosk-text-primary">
    <FontAwesomeIcon icon={faMoneyBillSimpleWave} />
    {price}
  </div>
);
